<template>
    <div class="input-wrapper">
        <TextEidtor class="custom-link-input-wrapper" v-bind="props" :value="value" @change="inputHandler" />
        <ErrorMessage v-show="!isValid" :message="message" />
    </div>
</template>

<script>
import TextEidtor from "@/views/zhiji/components/textEditor/Editor.vue";
import ErrorMessage from "./ErrorMessage";
import { checkRule, stringRequired } from "../rules.js";
import Validation from "../validation.js";

export default {
    name: "LinkTextInput",
    components: {
        TextEidtor,
        ErrorMessage
    },
    props: ["value", "widget", "rules", "validation"],
    data() {
        return {
            isValid: true,
            message: "",
            myValidation: null
        };
    },
    computed: {
        props() {
            return this.widget ? this.widget.props : {};
        },
        isError() {
            return this.verifyInfo && this.verifyInfo.isValid === false;
        }
    },
    created() {
        this.myValidation = new Validation({
            tiggerHanlder: () => this.validate(this.value),
            propName: this.widget && this.widget.name
        });
        this.validation && this.validation.addChild(this.myValidation);
    },
    destroyed() {
        this.myValidation && this.myValidation.destroy();
    },
    methods: {
        inputHandler(value) {
            const oldVal = this.value || {};
            if (oldVal.text === value.text && oldVal.linkWord === value.linkWord) {
                return;
            }
            const newValue = {
                linkWord: value.linkWord,
                text: value.text,
                cmd: value.cmd,
                cmdTagClassify: value.cmdTagClassify,
                isOld: value.isOld,
            };
            this.$emit("change", { ...newValue });
            this.validate(newValue);
            this.emitValid();
        },
        validate(newValue) {
            const { text } = newValue;
            const rules = (this.rules || []).map(rule => {
                if (rule.required) {
                    return { validator: stringRequired, message: rule.message || "请输入必要内容" };
                }
                return rule;
            });
            if (rules.length === 0) {
                return;
            }
            const result = checkRule(text, rules);
            this.isValid = result.isValid;
            this.message = result.message;
            return result;
        },
        emitValid() {
            this.myValidation && this.myValidation.emit({ isValid: this.isValid, message: this.message });
        }
    }
};
</script>

<style scoped lang="less">
.custom-link-input-wrapper {
    position: relative;
    width: 500px;
    height: 224px;
    border: 1px solid #d8e4f0;
    border-radius: 4px;
    /deep/ .text-edit-cmd-param {
        display: none;
    }
}
.input-wrapper {
    position: relative;
}
</style>
